const UTILS = {
  ConvertStringToJS(str) {
    var script = document.createElement("script");
    script.text = str;
    document.head.appendChild(script).parentNode.removeChild(script);
  },

  FormatMoney(value) {
    let price = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });
    return price.format(value / 100).replace(".00", "");
  },

  async AddItemsToCart(items_to_add) {
    // items_to_add = [{
    //   quantity: qty,
    //   id: variant_id,
    //   selling_plan: selling_plan_id,
    //   properties: {}
    // }]
    return await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: items_to_add }),
    });
  },

  async RefreshCart() {
    let $drawer =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    let sections = $drawer
      .getSectionsToRender()
      .map((item) => item.id)
      .join(",");
    let cart = await fetch("/cart.js").then((res) => res.json());
    let line_item_response = cart.items[0];

    if (!line_item_response) return;

    let sections_response = await fetch(`/?sections=${sections}`).then(
      (response) => response.json()
    );
    line_item_response.sections = sections_response;
    $drawer.renderContents(line_item_response);
    $drawer.classList.remove("is-empty");
  },

  /*
  async RefreshCart() {
    try {
      const $drawer =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");

      // Ensure the cart drawer exists before proceeding
      if (!$drawer) {
        console.error("Cart drawer not found.");
        return;
      }

      // Get sections to update (cart drawer and cart icon bubble)
      const sections = $drawer
        .getSectionsToRender()
        .map((item) => item.id)
        .join(",");

      // Fetch the current cart data
      const cart = await fetch("/cart.js").then((res) => res.json());

      if (!cart || cart.items.length === 0) {
        console.warn("Cart is empty.");
        $drawer.classList.add("is-empty");
        return;
      }

      // Fetch updated sections (using Shopify's sections API)
      const response = await fetch(
        `/?sections=${sections}&sections_url=${window.location.pathname}`
      ).then((res) => res.json());

      if (!response) {
        console.error("Failed to fetch updated sections.");
        return;
      }

      // Render the cart drawer with the updated sections
      $drawer.renderContents({
        id: cart.items[0].id,
        sections: response,
      });

      $drawer.classList.remove("is-empty");
    } catch (error) {
      console.error("Error refreshing the cart:", error);
    }
  },

  ensureCartDrawerInitialized() {
    // Check if the cart drawer exists and initialize it if necessary
    let $drawer = document.querySelector("cart-drawer");
    if (!$drawer) {
      console.error("Cart drawer is not initialized.");
      return false; // Prevent further actions if the drawer is not initialized
    }
    return true;
  },
  */
};

document.addEventListener("rebuy.add", (e) => {
  //UTILS.RefreshCart();
});

/*
document.addEventListener("rebuy.add", (e) => {
  
  if (UTILS.ensureCartDrawerInitialized()) {
    // Only refresh the cart if the cart drawer is properly initialized
    UTILS.RefreshCart();
  }
  });

document.addEventListener("cart:addtocart_complete", (e) => {
  if (UTILS.ensureCartDrawerInitialized()) {
    // Handle regular add-to-cart behavior
    UTILS.RefreshCart();
  }
});
*/

document.addEventListener("alpine:init", () => {
  let products = [];

  Alpine.data("ProductQuickAdd", () => ({
    $section: null,
    $productCard: null,
    $productForm: null,
    $variantId: null,
    product: null,
    hideSizes: true,
    mounted() {
      let am = this;
      am.$section = am.$el;
      am.$productForm = am.$section.querySelector("product-form form");
      am.$variantId = am.$productForm.querySelector('[name="id"]');
      am.$productCard = am.$section.closest(".product-card-wrapper");

      am.SetProduct();

      am.$section
        .querySelectorAll(".x-cloak-hidden")
        .forEach((item) => item.classList.remove("x-cloak-hidden"));

      document.addEventListener(
        "cart:addtocart_complete",
        am.OnAddToCartComplete.bind(am)
      );
    },
    SetProduct() {
      let am = this;
      UTILS.ConvertStringToJS(
        am.$section.querySelector("[data-product-json]").innerHTML
      );
      product.color_option = product.options_with_values.find(
        (option) => option.name == "Color"
      );
      product.size_option = product.options_with_values.find(
        (option) => option.name == "Size"
      );
      am.product = product;
      products.push(product);
    },
    ToggleSizes(toggle) {
      let am = this;
      am.hideSizes = !toggle;
    },
    GetSelectedVariant() {
      let am = this;
      let values = [...am.$section.querySelectorAll("input:checked")].map(
        (item) => item.value
      );
      let variant = am.product.variants.find((v) => {
        return v.options.join("/") === values.join("/");
      });

      return variant;
    },
    OnAddToCartComplete() {
      let am = this;
      am.ToggleSizes(false);
    },
    CheckPreorder(variant) {
      let am = this;
      let $preorderAttr = am.$productForm.querySelector(
        "#preorder_consolidated"
      );
      if (variant.mf.consolidated_pre_order_control) {
        $preorderAttr.setAttribute("name", "properties[Pre-order]");
        $preorderAttr.value = variant.mf.consolidated_pre_order_date_range;
      } else {
        $preorderAttr.setAttribute("name", "");
      }
    },
    CheckFinalSale(variant) {
      let am = this;
      let $finalSaleAttr = am.$productForm.querySelector(
        `#final_sale_quickadd_${variant.product_id}`
      );
      console.log(variant.compare_at_price, variant.title);
      if (variant.compare_price > variant.price) {
        $finalSaleAttr.setAttribute("name", "properties[Sale]");
        $finalSaleAttr.value = "Final Sale";
      } else {
        $finalSaleAttr.setAttribute("name", "");
      }
    },
    e_ToggleSizes(e, toggle) {
      let am = this;
      if (
        am.product.variants.length == 1 ||
        (am.product.color_option && !am.product.size_option)
      ) {
        am.e_QuickAddToCart(e);
        return;
      }

      am.ToggleSizes(toggle);
    },
    e_QuickAddToCart(e) {
      let am = this;
      let variant = am.GetSelectedVariant();

      am.CheckPreorder(variant);
      am.CheckFinalSale(variant);

      if (!variant) {
        console.warn("No variant selected");
        return;
      }

      if (!am.$variantId) return;
      am.$variantId.value = variant.id;

      if (!am.$productForm) return;
      am.$productForm.dispatchEvent(new Event("submit", { bubbles: true }));
    },
    e_ShowColorImage() {
      let am = this;
      let variant = am.GetSelectedVariant();

      if (!variant.media) return;

      let $productCard = am.$section.closest(".product-card-wrapper");
      if (!$productCard) return;

      let $image = $productCard.querySelector(".card__media img:last-of-type");
      if (!$image) return;

      $image.setAttribute("src", variant.media.src);
      $image.setAttribute("srcset", `${variant.media.src}?width=533`);
    },
    e_UpdateAvailableSizes(e) {
      let am = this;
      let target = e.currentTarget;
      let color = target.value;
      let color_option_id = `option${am.product.color_option.position}`;

      if (!am.product.size_option) return;

      let size_option_id = `option${am.product.size_option.position}`;
      let matching_variants = am.product.variants.filter(
        (v) => v[color_option_id] === color
      );

      am.product.size_option.values.forEach((size) => {
        let size_variant = matching_variants.find(
          (v) => v[size_option_id] == size
        );
        am.$productCard
          .querySelectorAll(`.size-swatches input[value="${size}"]`)
          .forEach(($size) => {
            $size.disabled = !size_variant.available;
          });
      });
    },
  }));

  Alpine.data("QuickAddDesktop", () => ({
    $section: null,
    $productCard: null,
    $productForm: null,
    hideSizes: true,
    mounted() {
      let am = this;
      am.$section = this.$el;
      am.$productCard = am.$section.closest(".product-card-wrapper");
      am.$productForm = am.$productCard.querySelector("product-form form");

      am.SetProduct();

      am.$section
        .querySelectorAll(".x-cloak-hidden")
        .forEach((item) => item.classList.remove("x-cloak-hidden"));

      document.addEventListener(
        "cart:addtocart_complete",
        am.OnAddToCartComplete.bind(am)
      );
    },
    SetProduct() {
      let am = this;
      UTILS.ConvertStringToJS(
        am.$productCard.querySelector("[data-product-json]").innerHTML
      );
      product.color_option = product.options_with_values.find(
        (option) => option.name == "Color"
      );
      product.size_option = product.options_with_values.find(
        (option) => option.name == "Size"
      );
      am.product = product;
    },
    ToggleSizes(toggle) {
      let am = this;
      am.hideSizes = !toggle;
    },
    OnAddToCartComplete() {
      let am = this;
      am.ToggleSizes(false);
    },
    e_ToggleSizes(e, toggle) {
      let am = this;

      if (
        am.product.variants.length == 1 ||
        (am.product.color_option && !am.product.size_option)
      ) {
        am.$productForm.dispatchEvent(new Event("submit"));
        return;
      }
      am.ToggleSizes(toggle);
    },
    e_QuickAddToCart(size) {
      let am = this;
      let $quickadd_main = am.$productCard.querySelector(".quick-add-mainform");
      let $size = $quickadd_main.querySelector(
        `.size-swatches input[value="${size}"]`
      );
      $size.checked = true;
      $size.dispatchEvent(new Event("change", { bubbles: true }));

      let $sizeLabel = $quickadd_main.querySelector(
        `.size-swatches label[data-size="${size}"]`
      );
      $sizeLabel.dispatchEvent(new Event("click", { bubbles: true }));
    },
  }));

  Alpine.data("BundleBuilder", () => ({
    $section: null,
    $product_cards: [],
    bundle_items: [],
    variants_to_add: [],
    price_total: 0,
    price_bundle: 0,
    selected_size: null,
    max_count: 7,
    mounted() {
      let am = this;
      am.$section = am.$el;
      am.$section.style.setProperty(
        "--header-height",
        `${document.querySelector(".header-wrapper").clientHeight}px`
      );
      am.$product_cards = am.$section.querySelectorAll(".product-card");
      am.$section.removeAttribute("x-cloak");

      /*
      am.$product_cards.forEach(($product) => {
        $product
          .querySelector(".color-swatches")
          .addEventListener("change", (e) => {
            am.UpdateAvailableColors();
          });
      });
*/
      am.$watch("bundle_items", am.UpdateBundlePrice.bind(am));

      /*
      am.$watch("bundle_items", () => {
        let variants_to_add = [];
        am.bundle_items.forEach((bundle_item) => {
          let existing_item = variants_to_add.find(
            (item) => item.id == bundle_item.id
          );
          let quantity = !existing_item ? 1 : existing_item.quantity + 1;

          if (!existing_item) {
            variants_to_add.push({
              id: bundle_item.id,
              quantity: quantity,
              properties: {
                "Pre-order": bundle_item.mf.consolidated_pre_order_control
                  ? "Yes"
                  : "No",
                "Pre-order Date":
                  bundle_item.mf.consolidated_pre_order_date_range || "",
              },
            });
          } else {
            existing_item.quantity = quantity;
          }
        });
        am.variants_to_add = variants_to_add;
      });
      */
      am.$watch("bundle_items", () => {
        let variants_to_add = [];
        am.bundle_items.forEach((bundle_item) => {
          let existing_item = variants_to_add.find(
            (item) => item.id === bundle_item.id
          );
          let quantity = !existing_item ? 1 : existing_item.quantity + 1;

          let variantData = {
            id: bundle_item.id,
            quantity: quantity,
            properties: {},
          };

          // Add preorder properties if applicable
          if (bundle_item.mf.consolidated_pre_order_control) {
            variantData.properties = {
              "Pre-order":
                bundle_item.mf.consolidated_pre_order_date_range || "",
            };
          }

          // Add to variants_to_add array
          if (!existing_item) {
            variants_to_add.push(variantData);
          } else {
            existing_item.quantity = quantity;
          }
        });
        am.variants_to_add = variants_to_add;
      });
    },
    e_SelectSize(e) {
      let am = this;
      am.selected_size = e.target.value;
      am.UpdateAvailableColors();
    },

    e_AddToBundle(e) {
      let am = this;
      if (e.target.classList.contains("disabled")) return;
      let $product = e.target.closest(".product-card");
      let product_id = $product.dataset.product_id;
      let product = products.find((p) => p.id == product_id);
      let color = $product.querySelector(".color-swatches input:checked").value;
      let values = [color, am.selected_size];
      let variant = product.variants.find((v) => {
        return v.options.join("/") === values.join("/");
      });
      if (am.bundle_items.length == am.max_count) return;
      am.bundle_items.push(variant);
    },

    e_RemoveItem(e, index) {
      let am = this;
      am.bundle_items.splice(index, 1);
    },
    e_ToggleSelectionItems(e) {
      let am = this;
      am.$section
        .querySelector(".selected-items-wrap")
        .classList.toggle("active");
    },
    async e_AddRemainingBundleItems(e) {
      let am = this;
      let $form = e.target.closest("form");
      if (am.variants_to_add.length == 1) {
        $form.dispatchEvent(new Event("submit", { bubbles: true }));
        return;
      }

      let remaining_items = [...am.variants_to_add].splice(
        (am.variants_to_add.length - 1) * -1
      );
      UTILS.AddItemsToCart(remaining_items).then((res_atc) => {
        $form.dispatchEvent(new Event("submit", { bubbles: true }));
      });
    },
    UpdateAvailableColors() {
      let am = this;
      am.$product_cards.forEach(($product) => {
        let product_id = $product.dataset.product_id;
        let product = products.find((p) => p.id == product_id);
        if (!product.color_option) return;
        product.color_option.values.forEach((color) => {
          let values = [color, am.selected_size];
          let variant = product.variants.find((v) => {
            return v.options.join("/") === values.join("/");
          });
          if (!variant) return;
          let $color = $product.querySelector(`input[value="${color}"]`);
          $color.disabled = !variant.available;

          if ($color.checked) {
            $product
              .querySelector(".btn-add-item")
              .classList.toggle("disabled", !variant.available);
          }
        });
      });
    },
    UpdateBundlePrice() {
      let am = this;
      am.price_total = am.bundle_items.reduce(
        (sum, variant) => sum + variant.price,
        0
      );
      if (am.bundle_items.length == 2) {
        am.price_bundle = am.price_total * 0.95;
      } else if (am.bundle_items.length > 2 && am.bundle_items.length <= 5) {
        am.price_bundle = am.price_total * 0.9;
      } else if (am.bundle_items.length > 5) {
        am.price_bundle = am.price_total * 0.85;
      } else {
        am.price_bundle = am.price_total;
      }
    },
  }));

  Alpine.data("VariantCollection", () => ({
    $section: null,
    $product_cards: [],
    bundle_items: [],
    variants_to_add: [],
    selected_size: null,
    max_count: 7,
    mounted() {
      let am = this;
      am.$section = am.$el;
      am.$product_cards = am.$section.querySelectorAll(".product-card");
      am.$section.removeAttribute("x-cloak");
    },
    e_SelectSize(e) {
      let am = this;
      am.selected_size = e.target.value;
    },
  }));
});

/*
document.addEventListener('rebuy:cart.change', (event) => { 
  console.log('rebuy:cart.change event', event.detail); 
  const widget = window?.Rebuy?.widgets?.find(w => w.id == '106768');

  if (widget) {
    widget.destroy();
    console.log('Widget has been destroyed');
  }


  setTimeout(()=>{

    Rebuy.init();
    console.log('Rebuy.init called');

  }, 1000)

  
});
*/

const updateCartOffers = () => {
  const widget = window?.Rebuy?.widgets?.find((w) => w.id == "106768");
  const target = document.getElementById("cart-drawer-offers");

  target.innerHTML = "";

  if (widget) {
    widget.destroy();
    console.log("Widget has been destroyed");
  }

  setTimeout(() => {
    if (target) {
      target.insertAdjacentHTML(
        "beforeend",
        '<div data-rebuy-id="106768"></div>'
      );
      Rebuy?.init();
      console.log("Rebuy.init called");
    }
  });
};

document.addEventListener("rebuy:cart.change", (event) => {
  //console.log('rebuy:cart.change -> updateCartOffers', event);
  //updateCartOffers();
});

document.addEventListener("cart:ui:updated", (event) => {
  console.log("cart:ui:updated -> updateCartOffers", event);

  updateCartOffers();

  if (window.listenForUpdate) {
    delete window.listenForUpdate;
    document.querySelector("cart-drawer-items").onCartUpdate();
    console.log("cart:ui:updated - Update listened for and refreshed!");
  }
});

document.addEventListener("rebuy.add", (event) => {
  console.log("rebuy.add event", event);
  window.listenForUpdate = true;
  document.querySelector("cart-drawer-items").onCartUpdate();
});
